var DomHelper = /** @class */ (function () {
    function DomHelper() {
    }
    DomHelper.prototype.addClass = function (element, classString) {
        if (element) {
            element.className = element
                .className
                .split(' ')
                .filter(function (name) {
                return name !== classString;
            })
                .concat(classString)
                .join(' ');
        }
    };
    DomHelper.prototype.removeClass = function (element, classString) {
        if (element) {
            element.className = element
                .className
                .split(' ')
                .filter(function (name) {
                return name !== classString;
            })
                .join(' ');
        }
    };
    DomHelper.prototype.isMobile = function () {
        var SMALL_SCREEN_BREAKPOINT = 768;
        return window.screen.width < SMALL_SCREEN_BREAKPOINT;
    };
    DomHelper.prototype.scrollFrom = function (parent, child, distance) {
        parent.scrollTo(0, child['offsetTop'] + distance);
    };
    return DomHelper;
}());
export { DomHelper };
